export const shippingAccounts = {
	shippingAccounts: {
		noShippingAccountsAvailable: 'No Shipping Accounts available',
	}
};